import React from 'react';
import { useContext } from 'react';
import { store } from 'components/Store';
import normalize from 'components/Dashboard/utilities/normalizeString';
import array_move from 'components/Dashboard/helpers/arrayMove';
import { useState } from 'react';
import InfluenceNotIncludedFeaturesPopup from 'components/Dashboard/Influence/CrmContacts/InfluenceNotIncludedFeaturesPopup';
import { useResearchItemsUrl } from 'components/Dashboard/Navigation/NavPages';
import { NavLink, useLocation } from 'react-router';
import getAppSite from 'utils/getAppSite';

const RenderLink = (props) => {
  const location = useLocation();

  const { item, closeMenu, setShowPopup, setTypePopup } = props;
  const { stakeholderTopicParam } = useResearchItemsUrl();

  const { name, icon, disabled } = item;
  let link = name;
  if (name === 'Directory') {
    link = 'directory';
  } else if (name === 'My lobbying material' || name === 'Lobbying material') {
    link = `/brief-policymakers/lobbying-material`;
  } else if (name === 'Engagement statistics') {
    link = '/brief-policymakers/engagement-statistics';
  } else if (name === 'Stakeholder mapping') {
    link = `/people/stakeholder-mapping${stakeholderTopicParam}`;
  } else if (name === 'Email campaigns') {
    link = 'emails';
  } else if (name === 'Interactions') {
    link = 'interactions';
  }

  return (
    <li key={normalize(name)}>
      <NavLink
        to={
          name === 'My lobbying material' ||
          name === 'Lobbying material' ||
          name === 'Stakeholder mapping' ||
          name === 'Engagement statistics'
            ? link
            : `/people/${normalize(link)}`
        }
        state={{}}
        className={({ isActive }) =>
          `${isActive ? 'active' : ''} sidebar-item ${normalize(name === 'Inbox' ? 'influence-inbox' : name)}-a ${
            name === 'My lobbying material' && location.pathname === '/brief-policymakers/lobbying-material'
              ? 'active'
              : ''
          }`
        }
        onClick={(e) => {
          if (disabled && setShowPopup) {
            e.preventDefault();
            let createTypePopup = () => {
              switch (name) {
                case 'Stakeholder mapping':
                  return 'stakeholders';
                case 'Email campaigns':
                  return 'email';
                case 'Interactions':
                  return 'contacts';
                default:
                  return 'contacts';
              }
            };
            setTypePopup(createTypePopup());
            setShowPopup(true);
          } else {
            if (closeMenu) {
              closeMenu();
            }
          }
        }}
      >
        <div className='row mx-0 align-items-center'>
          <div className={`icon-container-${icon}`}>
            <span className={`icon-${icon}`} />
          </div>
          <span>{name}</span>
        </div>
      </NavLink>
    </li>
  );
};

const InfluenceCrmSideBar = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { crmContactsQtty, activePlan } = state;

  const { closeMenu, mobile } = props;
  const [typePopup, setTypePopup] = useState('contacts');
  const { enableCrm, enableStakeholders } = activePlan;
  const [showPopup, setShowPopup] = useState(false);

  const location = useLocation();
  const briefPolicymakersSection = location.pathname.includes('/brief-policymakers');

  const crmPeopleSections = [
    { name: 'Directory', disabled: !enableCrm, icon: 'directory' },
    { name: 'My groups', disabled: !enableCrm, icon: 'team' },
    { name: 'Stakeholder mapping', icon: 'graph', disabled: !enableStakeholders },
  ];
  const crmConversationSections = [
    { name: 'Interactions', disabled: !enableCrm, icon: 'chat' },
    { name: 'Email campaigns', disabled: !enableCrm, icon: 'email' },
    { name: 'Engagement stats', disabled: !enableCrm, icon: 'bars-low' },
  ];
  let crmCampaignSections = [
    { name: 'Lobbying material', icon: 'briefing-material' },
    { name: 'Engagement statistics', icon: 'statistics' },
  ];

  let menuItems = [
    {
      name: 'People',
      items: crmPeopleSections,
      includeCrmContactsQtty: true,
      titleClass: 'sidenav-subtitle-influence-page',
    },
    {
      name: 'Engagement',
      items: crmConversationSections,
    },
  ];

  if (briefPolicymakersSection) {
    menuItems = [
      {
        name: `Brief policymakers`,
        items: crmCampaignSections,
        hidden: getAppSite() === 'usa',
      },
    ];
  }

  if (!enableStakeholders) {
    let position = menuItems.findIndex((item) => item.name === 'Lobbying material');
    menuItems = array_move(menuItems, position, 0);
  }

  return (
    <>
      {mobile ? (
        <div>
          <ul className='px-0 mb-0 overflow-hidden sidenav-list unstyled-list sidebar-influence'>
            {menuItems
              .filter((item) => !item.hidden)
              .map((section) => {
                const { items, includeCrmContactsQtty, name } = section;
                let properties = { closeMenu, setShowPopup, setTypePopup };
                if (includeCrmContactsQtty) {
                  properties = { ...properties, crmContactsQtty };
                }
                return (
                  <React.Fragment key={normalize(name)}>
                    {items.map((item) => {
                      return <RenderLink key={`item-${normalize(item.name)}`} {...properties} item={item} />;
                    })}
                  </React.Fragment>
                );
              })}
          </ul>
        </div>
      ) : (
        <div>
          <ul className='px-0 mb-0 overflow-hidden sidenav-list unstyled-list sidebar-influence'>
            {menuItems
              .filter((item) => !item.hidden)
              .map((section) => {
                const { items, includeCrmContactsQtty, name, titleClass } = section;
                let properties = { setShowPopup, setTypePopup };
                if (includeCrmContactsQtty) {
                  properties = { ...properties, crmContactsQtty };
                }
                return (
                  <React.Fragment key={normalize(name)}>
                    {name && <h3 className={`mt-4 mb-3 title-h5-m-bold pl-lg-3 ${titleClass ?? ''}`}>{name}</h3>}
                    {items.map((item) => {
                      return <RenderLink key={`item-${normalize(item.name)}`} {...properties} item={item} />;
                    })}
                  </React.Fragment>
                );
              })}
          </ul>
        </div>
      )}
      <InfluenceNotIncludedFeaturesPopup showPopup={showPopup} type={typePopup} setShowPopup={setShowPopup} />
    </>
  );
};

export { RenderLink };
export default InfluenceCrmSideBar;
